var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 6.75C27.4142 6.75 27.75 6.41421 27.75 6C27.75 5.58579 27.4142 5.25 27 5.25V6.75ZM0.469669 5.46967C0.176777 5.76256 0.176777 6.23744 0.469669 6.53033L5.24264 11.3033C5.53553 11.5962 6.01041 11.5962 6.3033 11.3033C6.59619 11.0104 6.59619 10.5355 6.3033 10.2426L2.06066 6L6.3033 1.75736C6.59619 1.46447 6.59619 0.989593 6.3033 0.696699C6.01041 0.403806 5.53553 0.403806 5.24264 0.696699L0.469669 5.46967ZM27 5.25L1 5.25V6.75L27 6.75V5.25Z","fill":"#FD6500"}));
}

BackArrow.defaultProps = {"width":"28","height":"12","viewBox":"0 0 28 12","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
